const urls = {
  objectURLs: ["./glb/pyramid.glb", "./glb/ring.glb", "./glb/spikeCube.glb"],
  evilAudio: ["audio/electroStatic.mp3"],
  happyAudio: ["audio/heroStack.mp3"],
  textures: []
};

const Assets = {
  objects: [],
  audio: [],
  textures: []
};

export const getObjectURLs = () => {
  return urls.objectURLs;
};

export const getEvilAudioURL = () => {
  return urls.evilAudio;
};
export const getHappyAudioURL = () => {
  return urls.happyAudio;
};

export const getTextureURL = () => {
  return urls.textures;
};

export const getObjects = () => {
  return Assets.objects;
};

export const getAudio = () => {
  return Assets.audio;
};

export const getTexture = () => {
  return Assets.textures;
};

export const getAssets = () => {
  return Assets;
};

export const addObject = asset => {
  Assets.objects.push(asset);
};

export const addAudio = asset => {
  Assets.audio.push(asset);
};

export const addTexture = asset => {
  Assets.textures.push(asset);
};

export const addNewAsset = (name, asset) => {
  Assets[name] = asset;
};

export const addToAsset = (name, asset) => {
  const assetProperty = Assets[name];
  if (assetProperty instanceof Array) Assets[name].push(asset);
  else return console.log("Not an array!");
};
